<template>
  <form class="bg-beige-academy-100 bg-opacity-70 text-center"
    @submit.prevent="addTier">
    <div class="flex items-center justify-end bg-beige-academy-300 text-white w-full py-7 relative">
      <h1 class="uppercase text-xl self-center w-full absolute">{{ $t('tier.new') }}</h1>
      <button @click.prevent="$modal.hide('add-tier')" class="px-4 z-20">
        <close-icon />
      </button>
    </div>
    <div class="flex flex-col w-5/6 mx-auto pb-6 font-sans-serif">
      <div class="flex py-6 items-center">
        <label for="lesson-type" class="uppercase font-sans-serif w-1/3 text-left">
          {{$t('tier.name')}}:
        </label>
        <input type="text" id="lesson-type" class="border border-background-academy
        bg-beige-academy-200 outline-none w-2/3 py-2 pl-2" v-model="tier.name" required>
      </div>
      <div class="flex py-3 items-start">
        <label for="lesson-description" class="uppercase font-sans-serif w-1/3 text-left pt-2">
           {{$t('tier.description')}}:
        </label>
        <textarea type="text" id="lesson-description" class="border border-background-academy
        bg-beige-academy-200 outline-none w-2/3 py-2 pl-2" rows="3" v-model="tier.description"
        required />
      </div>
      <div class="flex py-3 items-center">
        <label for="lesson-price" class="uppercase font-sans-serif w-1/3 text-left">
          {{$t('tier.price')}}:
        </label>
        <currency-input
          v-model="tier.price"
          name="lesson-price"
          id="lesson-price"
          :locale="$i18n.locale"
          :currency="currency"
          :auto-decimal-mode="true"
          :value-as-integer="true"
          class="border border-background-academy
          bg-beige-academy-200 outline-none w-1/3 py-2 pl-2" />
      </div>
      <div class="flex py-3 items-center">
        <label for="lesson-number" class="uppercase font-sans-serif w-1/3 text-left">
         {{$t('tier.number')}}:
        </label>
        <input type="number" id="lesson-number" class="border border-background-academy
        bg-beige-academy-200 outline-none w-1/3 py-2 pl-2" min="1" v-model="tier.no_lessons">
      </div>
      <div class="flex w-full items-center">
        <label for="template" class="uppercase font-sans-serif w-1/3 text-left">
           {{$t('tier.choose')}} template:
          </label>
        <md-field class="w-2/3">
          <md-select v-model="tier.classroom_template_id" id="template"
            :class="isTeacher ? 'bg-beige-academy-100 text-grey-academy-300' :
            'bg-orange-academy-300 text-white'"
            class="flex w-full relative capitalize font-sans-serif pl-2
            border border-background-academy py-1">
            <md-option v-for="template of templates" :value="template.id"
              :key="template.id"
              class="capitalize font-sans-serif bg-white
              backdrop-filter backdrop-blur-lg backdrop-opacity-10"
              :class="isTeacher ? 'hover:bg-beige-academy-100 hover:text-grey-academy-300' :
              'hover:bg-orange-academy-300 hover:text-white'">
              {{ template.description }}
            </md-option>
          </md-select>
        </md-field>
      </div>
      <div class="flex py-3 items-start w-full">
        <label for="lesson-price" class="uppercase font-sans-serif w-1/3 text-left">
          {{$t('tier.choose')}} {{$t('tier.color')}}:
        </label>
        <div class="flex flex-col">
          <button v-if="!showColors" class="flex items-center" @click="showColors = !showColors">
            <div class="w-10 h-6 rounded-sm border border-background-academy"
            :style="{ 'background-color': color.hex ? color.hex : color}" />
            <dropdown-arrow />
          </button>
          <swatches-picker v-model="color" v-else />
        </div>
      </div>
      <!--<div class="flex py-3 items-start w-full">
        <label for="lesson-price" class="uppercase font-sans-serif w-1/3 text-left">
          {{$t('tier.choose')}} {{$t('tier.icon')}}:
        </label>
        <div class="flex flex-col w-2/3">
          <button v-if="!showIcons" class="flex items-center" @click="showIcons = !showIcons">
            <i class="medium material-icons" v-if="icon">{{icon}}</i>
            <div v-else class="w-5 h-5 border-dashed border-2 mr-1 border-gray-600"></div>
            <dropdown-arrow />
          </button>
          <icon-picker v-else @selected="changeIcon($event)" />
        </div>
      </div>-->
    </div>
    <div class="flex items-center justify-center pb-10">
      <modal-button button-class="uppercase text-lg" :button-placeholder="$t('tier.save')" />
    </div>

  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import { getTeacherTemplates } from '@/services/TeacherService';
import DropdownArrow from '@/components/graphics/DropdownArrow.vue';
import { CurrencyInput } from 'vue-currency-input';
import ModalButton from '../graphics/ModalButton.vue';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  data() {
    return {
      tier: {
        name: '',
        description: '',
        price: 0,
        no_lessons: 1,
        package: false,
        material: false,
        classroom_template_id: '',
        color: '#F7F2E9',
      },
      color: '#F7F2E9',
      showColors: false,

      icon: null,
      showIcons: false,

      templates: [],

      currency: process.env.VUE_APP_CURRENCY,
    };
  },

  components: {
    DropdownArrow,
    CurrencyInput,
    ModalButton,
    CloseIcon,
  },

  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
      user: 'auth/user',
    }),

    isPackage() {
      if (this.tier.no_lessons > 1) {
        return true;
      }
      return false;
    },
  },

  watch: {
    color() {
      this.showColors = false;
    },
  },

  created() {
    this.getTemplates();
  },

  methods: {
    getTemplates() {
      getTeacherTemplates(this.user.teacher.id).then(({ data }) => {
        this.templates = [];
        this.templates = data;
      });
    },

    addTier() {
      this.tier.package = this.isPackage;
      this.tier.color = this.color.hex ? this.color.hex : this.color;
      if (this.icon) this.tier.icon = this.icon;
      axios.post(`/api/teachers/${this.user.teacher.id}/tiers`, this.tier).then(() => {
        this.$emit('tierAdded');
        this.$modal.hide('add-tier');
      });
    },

    changeIcon(selectedIcon) {
      this.icon = selectedIcon;
      this.showIcons = false;
    },
  },
};
</script>
